import React from "react";
import { getDefaultImage } from "../../utils/GeneralUtils";
import styles from "./affiliation.module.scss";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  name: string;
  color?: string;
  link: string;
  img?: string;
};
export const Affiliation: React.FC<Props> = ({ name, color, link, img }) => {
  return (
    <>
      {link ? (
        <SonicLink to={link} className={styles["affiliation__link"]}>
          <div className={styles["affiliation"]}>
            <div className={styles["affiliation__imgBox-wrapper"]}>
              <div className={styles["affiliation__imgBox"]}>
                <img src={img || getDefaultImage()} />
                <span
                  className={styles["affiliation-border"]}
                  style={
                    color
                      ? {
                          backgroundColor: color,
                        }
                      : { backgroundColor: "#f79b00" }
                  }
                ></span>
                <span className={styles["affiliation__team"]}>
                  チームを見る
                </span>
              </div>
            </div>
            <span className={styles["affiliation__text"]}>{name}</span>
          </div>
        </SonicLink>
      ) : (
        <div className={styles["affiliation"]}>
          <div className={styles["affiliation__imgBox-wrapper"]}>
            <div className={styles["affiliation__imgBox"]}>
              <img src={img || getDefaultImage()} />
            </div>
          </div>
          <span className={styles["affiliation__text"]}>{name}</span>
        </div>
      )}
    </>
  );
};

export default Affiliation;
